<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ $t('settings') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('settings') }}</h1>
          <p class="lead text-muted"></p>
        </div>
      </header>
      <div class="row">
        <div class="col-md-2 d-flex flex-column">
          <ul class="nav nav-pills flex-column">

            <li class="nav-item" data-toggle="tooltip" data-placement="right">
              <router-link :to="{name: $i18n.locale + 'ListProperties'}" class="nav-link">
                <span class="title">
                  {{ $t('properties') }}
                </span>
              </router-link>
            </li>

            <li class="nav-item" data-toggle="tooltip" data-placement="right" v-if="properties.length">
              <router-link :to="{name: $i18n.locale + 'ListRooms', params: { property: properties[0].slug }}" class="nav-link">
                <span class="title">
                  {{ $t('rooms') }}
                </span>
              </router-link>
            </li>

            <!--<li class="nav-item" data-toggle="tooltip" data-placement="right">
              <router-link :to="{name: $i18n.locale + 'Profile'}" class="nav-link">
                <span class="title">
                  {{ $t('profile') }}
                </span>
              </router-link>
            </li>-->

            <li class="nav-item" data-toggle="tooltip" data-placement="right" v-if="properties.filter(p => p.apis && p.apis.blagajna && p.apis.blagajna.premise && p.apis.blagajna.premise._id).length">
              <router-link :to="{name: $i18n.locale + 'ListPrices', params: { property: properties.filter(p => p.apis && p.apis.blagajna && p.apis.blagajna.premise && p.apis.blagajna.premise._id)[0].slug }}" class="nav-link">
                <span class="title">
                  {{ $t('prices') }}
                </span>
              </router-link>
            </li>

            <li class="nav-item" data-toggle="tooltip" data-placement="right"  v-if="properties.filter(p => p.apis && p.apis.blagajna && p.apis.blagajna.premise && p.apis.blagajna.premise._id).length">
              <router-link :to="{name: $i18n.locale + 'ListPaymentMethods', params: { property: properties.filter(p => p.apis && p.apis.blagajna && p.apis.blagajna.premise && p.apis.blagajna.premise._id)[0].slug }}" class="nav-link">
                <span class="title">
                  {{ $t('paymentMethods') }}
                </span>
              </router-link>
            </li>


          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Settings',
  data: () => ({
    properties: []
  }),
  created(){
    this.properties = this.$store.state.host.properties;
  }
}
</script>

<i18n>
{
  "en": {
    "settings": "Settings",
    "properties": "Properties",
    "rooms": "Rooms",
    "profile": "Profile",
    "prices": "Prices",
    "paymentMethods": "Payment Methods"
  },
  "sl": {
    "settings": "Nastavitve",
    "properties": "Nastanitve",
    "rooms": "Sobe",
    "profile": "Profil",
    "prices": "Cene",
    "paymentMethods": "Plačilna sredstva"
  }
}
</i18n>
